'use client';

import { BackLink } from '@/components/back-link';
import {
  PageBreadcrumbs,
  PageBreadcrumbsProps
} from '@/components/page-breadcrumbs';
import { PageTitle, PageTitleProps } from '@/components/page-title';
import {
  SocialShareButton,
  SocialShareButtonProps
} from '@/components/social-share/social-share-button';
import { Container, ContainerProps } from '@mui/material';
import { LinkProps } from '@mui/material/Link';
import Stack, { StackProps } from '@mui/material/Stack';
import { ReactNode } from 'react';

export type PageLayoutProps = ContainerProps<'div'> & {
  StackProps?: StackProps<'div'>;
  PageTitleProps?: PageTitleProps;
  PageBreadcrumbsProps?: PageBreadcrumbsProps;
  BackLinkProps?: LinkProps;
  SocialShareButtonProps?: SocialShareButtonProps;
  Filters?: ReactNode;
};

export function PageLayout({
  StackProps,
  PageTitleProps,
  PageBreadcrumbsProps,
  BackLinkProps,
  SocialShareButtonProps,
  Filters,
  sx,
  children,
  ...containerProps
}: PageLayoutProps) {
  return (
    <Container
      {...containerProps}
      sx={[
        { p: { xs: 2, sm: 3, md: 4, lg: 5 } },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <Stack spacing={2} direction="column" {...StackProps}>
        {(PageBreadcrumbsProps || BackLinkProps) && (
          <Stack alignItems="center" justifyContent="space-between">
            {PageBreadcrumbsProps && (
              <PageBreadcrumbs {...PageBreadcrumbsProps} />
            )}
            {!PageBreadcrumbsProps && BackLinkProps && (
              <BackLink {...BackLinkProps} />
            )}
            {SocialShareButtonProps && (
              <SocialShareButton {...SocialShareButtonProps} />
            )}
          </Stack>
        )}
        {PageTitleProps && (
          <Stack
            direction={Filters ? { xs: 'column', sm: 'row' } : 'row'}
            alignItems={Filters ? { xs: 'flex-start', sm: 'center' } : 'center'}
            justifyContent="space-between"
            spacing={Filters ? { xs: 2, sm: 0 } : 0}
          >
            <PageTitle {...PageTitleProps} />
            <Stack direction="row" alignItems="center" spacing={2}>
              {Filters}
              {!PageBreadcrumbsProps &&
                !BackLinkProps &&
                SocialShareButtonProps && (
                  <SocialShareButton {...SocialShareButtonProps} />
                )}
            </Stack>
          </Stack>
        )}
        {children}
      </Stack>
    </Container>
  );
}
